<template>
  <div>
    <a-page-header title="AI调用文案管理">
    </a-page-header>

    <a-card style="margin-top: 16px">
      <a-row :gutter="16">
        <a-col :span="8">
          <a-card hoverable @click="navigateToStages">
            <template #title>
              <FileTextOutlined /> 展示阶段管理
            </template>
            <p>管理诊断过程的展示阶段，定义前端诊断流程的虚拟步骤</p>
          </a-card>
        </a-col>
        <a-col :span="8">
          <a-card hoverable @click="navigateToLogItems">
            <template #title>
              <UnorderedListOutlined /> 日志项管理
            </template>
            <p>管理每个展示阶段下的日志内容，支持变量占位符和延迟控制</p>
          </a-card>
        </a-col>
        <a-col :span="8">
          <a-card hoverable @click="navigateToReplay">
            <template #title>
              <PlayCircleOutlined /> 会话回放
            </template>
            <p>查看和回放历史WebSocket会话，支持消息筛选和回放</p>
          </a-card>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import { FileTextOutlined, UnorderedListOutlined, PlayCircleOutlined } from '@ant-design/icons-vue';
import { useRouter } from 'vue-router';

export default {
  name: 'DiagnosisLogManage',
  components: {
    FileTextOutlined,
    UnorderedListOutlined,
    PlayCircleOutlined
  },
  setup() {
    const router = useRouter();

    const navigateToStages = () => {
      router.push({ name: 'diagnosis-display-stage' });
    };

    const navigateToLogItems = () => {
      router.push({ name: 'diagnosis-log-item' });
    };

    const navigateToReplay = () => {
      router.push({ name: 'websocket-session-replay' });
    };

    return {
      navigateToStages,
      navigateToLogItems,
      navigateToReplay
    };
  }
};
</script>

<style scoped>
.ant-card {
  cursor: pointer;
  transition: all 0.3s;
}

.ant-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}
</style>
